import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { axiosInstance } from "../../utils/networking";

const CaseCard = (props: any) => {
  return (
    props.case &&
    props.case._id && (
      <Link to={`/case?id=${props.case._id}`} target="_blank">
        <Card
          sx={{ height: 140, width: 140, cursor: "pointer", margin: "5px" }}
        >
          <CardContent>
            <Typography variant="subtitle1" component="div">
              {props.case.firmRecord["Company Name"]}
            </Typography>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {props.case.firmRecord["City"]}
            </Typography>
          </CardContent>
        </Card>
      </Link>
    )
  );
};

export default CaseCard;
